import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import Spinner from "../Utils/Spinner";

// Shown while a similarity fetch is in-flight. Purely presentational with no state.
const SimilarAnswersSuggestionsLoadingIndicator = ({ className }) => {
  const t = useFormatMessage();
  const loadingText = t(intlMessages.loading);

  const containerClassName = classNames(
    "similar-answers-suggestions",
    "similar-answers-suggestions-loading",
    "margin-y-sm",
    className
  );

  return (
    <div className={containerClassName}>
      <Spinner className="margin-right-xs" />
      <p className="text-muted text-sm">{loadingText}</p>
    </div>
  );
};

export default SimilarAnswersSuggestionsLoadingIndicator;

const intlMessages = defineMessages({
  loading: {
    id: "similarAnswers.loading",
    defaultMessage: "Recherche de contributions en rapport en cours..."
  }
});
